import React from 'react'
import { Link } from 'react-router-dom'
import { Alert, Button } from 'components/ui'

const formatDate = (value) => {
    if (!value) return null
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return null
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

const SubscriptionExpiredNotice = ({
    payload,
    showRenewAction = false,
    className = 'mb-4',
}) => {
    if (!payload?.message && !payload?.code) {
        return null
    }

    const periodEnd = formatDate(payload.currentPeriodEnd)
    const trialEnd = formatDate(payload.trialEndsAt)
    const isTrial = payload.code === 'TRIAL_EXPIRED' || payload.isTrialAccount

    return (
        <Alert type="warning" showIcon className={className}>
            <div className="space-y-2">
                <p className="font-semibold text-gray-900">
                    {payload.message || 'Your subscription is not active.'}
                </p>
                {payload.planName && (
                    <p className="text-sm text-gray-700">
                        Plan: <span className="font-medium">{payload.planName}</span>
                    </p>
                )}
                {payload.subscriptionStatus && (
                    <p className="text-sm text-gray-700">
                        Status: <span className="font-medium capitalize">{payload.subscriptionStatus}</span>
                    </p>
                )}
                {periodEnd && !isTrial && (
                    <p className="text-sm text-gray-700">
                        Period ended: <span className="font-medium">{periodEnd}</span>
                    </p>
                )}
                {trialEnd && isTrial && (
                    <p className="text-sm text-gray-700">
                        Trial ended: <span className="font-medium">{trialEnd}</span>
                    </p>
                )}
                {showRenewAction && (
                    <div className="pt-3">
                        <Link to="/renew-subscription">
                            <Button
                                variant="solid"
                                size="sm"
                                className="text-white"
                                style={{ backgroundColor: '#042663' }}
                            >
                                {isTrial ? 'Subscribe' : 'Renew subscription'}
                            </Button>
                        </Link>
                    </div>
                )}
            </div>
        </Alert>
    )
}

export default SubscriptionExpiredNotice
